import React from "react";

const StepConsultationType = ({ selected, onSelect }) => {
  const types = [
    {
      id: "onsite",
      label: "Vor-Ort-Beratung",
      duration: "60 Minuten",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
      ),
      recommended: true,
      description: "Persönliches Gespräch in unserem Büro in Wülfrath. Ideal für eine umfassende Beratung.",
    },
    {
      id: "phone",
      label: "Telefonberatung",
      duration: "30 Minuten",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.8a16 16 0 0 0 6.29 6.29l.95-.95a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
        </svg>
      ),
      recommended: false,
      description: "Bequem von zu Hause aus. Für erste Fragen und schnelle Orientierung.",
    },
  ];

  return (
    <div className="booking-card step-enter">
      <div className="step-badge">Schritt 2 von 6</div>

      <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '26px', fontWeight: 700, color: '#1e2b38', marginBottom: '8px', lineHeight: 1.2, letterSpacing: '-0.02em' }}>
        Beratungsart wählen
      </h2>
      <p style={{ fontSize: '14px', color: '#6b7a8d', marginBottom: '24px', fontFamily: 'var(--font-ui)' }}>
        Wie möchtest du beraten werden?
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {types?.map((type) => {
          const isSelected = selected === type?.id;
          return (
            <button
              key={type?.id}
              type="button"
              onClick={() => onSelect(type?.id)}
              style={{
                width: '100%',
                textAlign: 'left',
                padding: '18px',
                borderRadius: '16px',
                border: isSelected ? '1.5px solid #3E4954' : '1.5px solid #dde1e7',
                background: isSelected ? 'rgba(62,73,84,0.06)' : '#f8f9fa',
                cursor: 'pointer',
                transition: 'all 220ms cubic-bezier(0.22, 1, 0.36, 1)',
                transform: isSelected ? 'scale(1.01)' : 'scale(1)',
                boxShadow: isSelected ? '0 4px 20px rgba(62,73,84,0.12)' : 'none',
                outline: 'none',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
                <div style={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  background: isSelected ? '#3E4954' : '#eef0f3',
                  color: isSelected ? '#ffffff' : '#6b7a8d',
                  transition: 'all 220ms ease',
                }}>
                  {type?.icon}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginBottom: '4px' }}>
                    <span style={{ fontWeight: 700, color: '#1e2b38', fontFamily: 'var(--font-ui)', fontSize: '15px' }}>
                      {type?.label}
                    </span>
                    {type?.recommended && (
                      <span style={{ fontSize: '10px', background: '#eef0f3', color: '#3E4954', padding: '2px 8px', borderRadius: '100px', fontFamily: 'var(--font-ui)', fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase' }}>
                        Empfohlen
                      </span>
                    )}
                  </div>
                  <p style={{ fontSize: '12px', color: '#6b7a8d', fontFamily: 'var(--font-ui)', lineHeight: 1.5, margin: '0 0 6px 0' }}>
                    {type?.description}
                  </p>
                  <p style={{ fontSize: '11px', color: '#16a34a', fontFamily: 'var(--font-ui)', fontWeight: 600, margin: 0 }}>
                    ✓ 100% kostenlos – keine Verpflichtung
                  </p>
                </div>
                <div style={{
                  width: '20px',
                  height: '20px',
                  borderRadius: '50%',
                  border: isSelected ? '2px solid #3E4954' : '2px solid #c5cdd6',
                  background: isSelected ? '#3E4954' : 'transparent',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  marginTop: '2px',
                  transition: 'all 220ms ease',
                }}>
                  {isSelected && (
                    <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                      <path d="M2 6L5 9L10 3" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default StepConsultationType;